/**
 * Global Constants
 * Centralized location for all app-wide constants
 */

// API Endpoints
export const API_BASE_URL = 'https://lizard.chameleonpower.com/CDN';
export const PRODUCTS_BY_SERIES_URL = (seriesId) => `${API_BASE_URL}/ProductsBySeries/${seriesId}.json`;
export const ROOM_SCENES_URL = (seriesId) => `${API_BASE_URL}/RoomScenes/${seriesId}.json`;

// Series IDs
export const SERIES_IDS = {
    STYLES: '9700',
    PRODUCTS_9696: '9696',
    PRODUCTS_8615: '8615',
    PRODUCTS_8069: '8069',
    ROOM_SCENES: '9705',
};

// Size Options
export const SIZES = {
    TILE_18X18: '18x18',
    PLANK_6X36: '6x36',
};

export const SIZE_LABELS = {
    [SIZES.TILE_18X18]: '18x18in tile',
    [SIZES.PLANK_6X36]: '6x36in plank',
};

// Default Values
export const DEFAULTS = {
    THUMBNAIL_SIZE: '256',
    FOCUS: 500,
    SIZE: SIZES.TILE_18X18,
    PRODUCT_SELECTION: [-1, -1],
};

// UI Constants
export const SECTIONS = {
    STYLE: 'style',
    SIZE: 'size',
    BASE_ACCENT: 'base-accent',
};

// Product Attributes
export const PRODUCT_ATTRIBUTES = {
    ID: 'id',
    NAME: 'name',
    COLOR: 'color',
    DESCRIPTION: 'description',
    SPECIFIER: 'specifier',
    SERIES_ID: 'seriesID',
    MANUFACTURER_SERIES_NAME: 'manufacturerSeriesName',
    SKU: 'sku',
};

// Local Storage Keys
export const STORAGE_KEYS = {
    CURRENT_SELECTION: 'CURRENT_SELECTION',
    UPLOAD_SPECS: 'UPLOAD_SPECS',
    FAVORITES: 'favorites',
    REDIRECT_ACTION: 'REDIRECT_ACTION',
};

// Colors
export const COLORS = {
    PRIMARY: '#003057',
    SECONDARY: '#666',
    BORDER: '#e0e0e0',
    BACKGROUND: '#f5f5f5',
};
